import _JSXStyle from "styled-jsx/style";
import React, { useContext, useMemo } from 'react';
import useTheme from '../use-theme';
import withDefaults from '../utils/with-defaults';
import clsx from '../utils/clsx';
import { CardContext } from './card-context';
import { addColorAlpha, getNormalColor } from '../utils/color';
import { getNormalWeight } from '../utils/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  autoMargin: false,
  blur: false,
  border: false,
  width: '100%',
  height: 'auto',
  noPadding: false,
  borderWeight: 'light',
  className: ''
};

const CardFooter = ({
  children,
  blur,
  className,
  color,
  width,
  height,
  border: borderProp,
  borderColor,
  borderWeight,
  noPadding,
  autoMargin: autoMarginProp,
  ...props
}) => {
  const theme = useTheme();
  const {
    background,
    autoMargin: autoMarginContext
  } = useContext(CardContext);
  const autoMargin = useMemo(() => {
    return autoMarginContext !== undefined ? autoMarginContext : autoMarginProp;
  }, [autoMarginProp, autoMarginContext]);
  const bgColor = useMemo(() => {
    if (color) {
      return getNormalColor(color, theme.palette);
    }

    return background || theme.palette.background;
  }, [color, theme.palette, background]);
  const border = useMemo(() => {
    if (!borderProp) return 'none';
    return `${getNormalWeight(borderWeight)} solid ${getNormalColor(borderColor, theme.palette, theme.palette.border)}`;
  }, [borderWeight, theme.palette, borderColor, borderProp]);
  return /*#__PURE__*/_jsxs("div", { ...props,
    className: _JSXStyle.dynamic([["135585066", [width, height, theme.layout.gapHalf, theme.layout.gap, bgColor, border, theme.layout.radius, theme.layout.radius, addColorAlpha(bgColor, 0.4), theme.layout.gapQuarter]]]) + " " + (props && props.className != null && props.className || clsx('card-footer', {
      'auto-margin': autoMargin,
      blur,
      'no-padding': noPadding
    }, className) || ""),
    children: [children, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "135585066",
      dynamic: [width, height, theme.layout.gapHalf, theme.layout.gap, bgColor, border, theme.layout.radius, theme.layout.radius, addColorAlpha(bgColor, 0.4), theme.layout.gapQuarter],
      children: `.card-footer.__jsx-style-dynamic-selector{width:${width};height:${height};padding:${theme.layout.gapHalf} ${theme.layout.gap};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;color:inherit;background-color:${bgColor};font-size:0.875rem;border-top:${border};border-bottom-left-radius:${theme.layout.radius};border-bottom-right-radius:${theme.layout.radius};}.card-footer.blur.__jsx-style-dynamic-selector{-webkit-backdrop-filter:saturate(180%) blur(10px);backdrop-filter:saturate(180%) blur(10px);background:${addColorAlpha(bgColor, 0.4)};}.card-footer.no-padding.__jsx-style-dynamic-selector{padding:0;}.auto-margin.__jsx-style-dynamic-selector *{margin-top:0;margin-bottom:0;margin-right:${theme.layout.gapQuarter};}`
    })]
  });
};

const MemoCardFooter = /*#__PURE__*/React.memo(CardFooter);
export default withDefaults(MemoCardFooter, defaultProps);